import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import BottomToolbar from "./BottomToolbar"
import Loader from "./Loader"
import SelectedFilters from "./SelectedFilters"

export default function() {
    const {
        response: { products },
        loading,
    } = useAppState()

    const foundProducts = products && products.total > 0;
    const isMobile = window.innerWidth < 769;

    return (

      
   
            
            
                <div>
        {(foundProducts || (loading && foundProducts)) && (
            <Fragment>
                {/* <Sidebar /> */}
                <Toolbar mobile />
            </Fragment>
        )}
        <div
            style={loading ? "position: absolute;width:100%" : ""}
        >
            {loading && foundProducts ? (
                <>
                    {/* <SelectedFilters /> */}
                  <Toolbar />
                    <Loader />
                    <Products />
                </>
            ) : loading ? (
                <Loader />
            ) : foundProducts ? (
                <>
                    {/* <SelectedFilters /> */}
                 <Toolbar />
                    <Products />
                    <BottomToolbar />
                </>
            ) : (
                <NoResults />
            )}
        </div>
        </div>
  
       

    )
}
